'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var GridSystemSaveButtonController = function GridSystemSaveButtonController($scope, systemConfigButtonsUtilsService, saveButtonUtilsService, saveValidationService, $q, advancedHepGridValidationService, advancedHepGridReloadConfigurationCacheService, $log) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.validateGridErrorMessages = function () {
    return _.isFunction($scope.isValidationMessage) ? $scope.isValidationMessage() : false;
  };
  function customSaveValidation(editedRows, gridData) {
    return _.isFunction($scope.customSaveValidation) ? $scope.customSaveValidation(editedRows, gridData) : true;
  }
  $scope.validateChanges = function (editedRows, gridData, columns) {
    /*
    TODO: Nothing to Validate it will not require pass through this process if nothing will save,
    this code is moved here in order to preserve some actions in system configurations, need more
    data to implement a better way.
     */
    if (!_.size(editedRows)) {
      return true;
    }
    var isCustomValidationType = advancedHepGridValidationService.isCustomValidationType($scope.selected);
    var isHepGrid = !_.isUndefined($scope.selected);
    var columnValidationResult = saveValidationService.validateByColumnValidations(editedRows, gridData, columns, isCustomValidationType);
    if (columnValidationResult !== true && isHepGrid) {
      return columnValidationResult;
    }
    var customSaveValidationResult = customSaveValidation(editedRows, gridData);
    if (customSaveValidationResult !== true || columnValidationResult !== true) {
      return !(customSaveValidationResult !== true || columnValidationResult !== true);
    }
    return true;
  };
  $scope.save = function (editedRows, gridData) {
    if (_.isFunction($scope.customSave)) {
      return $scope.customSave(editedRows, gridData);
    } else {
      toastr.error('Save function is not available for this grid.');
      return $q.reject();
    }
  };
  function refreshGrid() {
    if (gridPanel.keepGridFilteringState) {
      return gridPanel.refreshGrid();
    }
    return systemConfigButtonsUtilsService.refreshGrid(gridPanel);
  }
  $scope.saveChanges = function () {
    if ($scope.validateGridErrorMessages()) {
      return;
    }
    var gridData = saveButtonUtilsService.getAllRows(gridPanel.jqxGridSettings);
    var editedRows = saveButtonUtilsService.getEditedRowsFromData(gridData);
    if ($scope.validateChanges(editedRows, gridData, gridPanel.jqxGridSettings.columns)) {
      $scope.save(editedRows, gridData).then(refreshGrid).then($scope.saveSuccessCallBack)["catch"](saveErrorCallback);
    } else {
      if (!advancedHepGridValidationService.isCustomValidationType($scope.selected, gridPanel)) {
        var errorMessage = $scope.customErrorMessage && $scope.customErrorMessage();
        toastr.error(errorMessage || advancedHepGridValidationService.customDefaultValidationErrorMessage(_.get($scope, 'selected')) || 'Validation error occurred');
      }
    }
  };
  function saveErrorCallback(response) {
    if ($scope.customSaveErrorMessage && _.isFunction($scope.customSaveErrorMessage)) {
      $scope.customSaveErrorMessage(response);
    }
  }
  $scope.saveSuccessCallBack = function () {
    toastr.success('Successfully saved configuration changes.');
    gridPanel.clearModifiedCells();
    try {
      if (_.get($scope.selected, 'type')) {
        advancedHepGridReloadConfigurationCacheService.reloadConfigurationCacheForType($scope.selected.type);
      }
    } catch (e) {
      $log.error('GridSystemSaveButtonController: onSuccessCallback - ' + e.message);
    }
  };
};
GridSystemSaveButtonController.$inject = ['$scope', 'SystemConfigButtonsUtilsService', 'SaveButtonUtilsService', 'SaveValidationService', '$q', 'AdvancedHepGridValidationService', 'AdvancedHepGridReloadConfigurationCacheService', '$log'];
module.exports = GridSystemSaveButtonController;